import React from 'react';
import AdminLoginPage from '../../pages/AdminLoginPage';
import { getAdminToken } from '../../utils/adminAuth';

const AdminProtectedRoute = ({ children }) => {
  if (!getAdminToken()) {
    return <AdminLoginPage />;
  }

  return children;
};

export default AdminProtectedRoute;
